import { fromJS } from 'immutable';
import config from '../../../config';
import actions from '../../constants/auth';
import history from '../../../history';
import {checkJsonResponse, checkJsonResponseWithMessage} from 'utils/actions';

export const changeSignInRemember = (data) => ({
  type: actions.AUTH_CHANGE_REMEMBER,
  data
});

export const acceptRegistration = (data) => ({
  type: actions.REGISTRATION_ACCEPT,
  data
});

export const authHasError = (data) => {
  return ({
    type: actions.AUTH_HAS_ERROR,
    data
  });
}

export const authIsLoading = (data) => ({
  type: actions.AUTH_IS_LOADING,
  data
})

export const changeLoginValue = (data, key) => ({
	type: actions.LOGIN_CHANGE_VALUE,
	key,
	data
});

export const changeRegistrationValue = (data, key) => ({
  type: actions.REGISTRATION_CHANGE_VALUE,
  key,
  data
});

export const changeLoginItem = (data) => ({
	type: actions.LOGIN_CHANGE_ITEM,
	data
});

export const cleanAuthForm = () => (dispatch) => {
  dispatch(authIsLoading(false));
  dispatch(authHasError(false));
};

export const changeRegistrationItem = (data) => ({
  type: actions.REGISTRATION_CHANGE_ITEM,
  data
});

export const signOut = () => {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');

  return {
    type: actions.SIGN_OUT
  };
};

export const signIn = () => (dispatch, getState) => {
  dispatch(authIsLoading(true));

  const options = {
    method: 'post',
    headers: {
      "Content-type": 'application/json',
    },
    body: JSON.stringify({
      username: getState().auth.get('loginItem').get('email'),
      password: getState().auth.get('loginItem').get('password')
    })
  };


  fetch(`${config.apiHost}/auth/token/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.SIGN_IN,
      data: json.token
    });

    history.push('/');
    if (getState().auth.get('remember')) {
      localStorage.setItem('token', json.token);
    } else {
      sessionStorage.setItem('token', json.token);
    }

    dispatch(authIsLoading(false));
  })
  .catch((e) => {
    console.log(e);
    dispatch(authHasError(true));
    dispatch(authIsLoading(false));
  });
};


export const registration = () => (dispatch, getState) => {
  dispatch(authIsLoading(true));

  const options = {
    method: 'post',
    headers: {
      "Content-type": 'application/json',
    },
    body: JSON.stringify(getState().auth.get('registrationItem'))
  };
  fetch(`${config.apiHost}/user/`, options)
  .then(checkJsonResponseWithMessage)
  .then((json) => {
    dispatch({
      type: actions.SIGN_IN,
      data: json.token
    });

    if (getState().auth.get('remember')) {
      localStorage.setItem('token', json.token);
    } else {
      sessionStorage.setItem('token', json.token);
    }
    dispatch(authIsLoading(false));
  })
  .catch((e) => {
    dispatch(authHasError(e));
    dispatch(authIsLoading(false));
  });
};

export const loadUser = () => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/user/current/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_USER,
      data
    })
  })
  .catch((e) => {
    dispatch(signOut())
  });
}

export const changePassword = (password1, password2, key) => (dispatch, getState) => {
  const options = {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    body: JSON.stringify({ password2, password1, key })
  };
  fetch(`${config.apiHost}/user/change_password/`, options)
    .then(checkJsonResponseWithMessage)
    .then((json) => {
      dispatch({
        type: actions.PASSWORD_CHANGE_SUCCESS,
        data: true
      })
    })
    .catch((e) => {
      dispatch({
        type: actions.PASSWORD_CHANGE_FAIL,
        data: e
      })
      console.log(e);
    });
}

export const forgotPassword = email => (dispatch, getState) => {
  const options = {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    body: JSON.stringify({ email })
  };
  fetch(`${config.apiHost}/user/change_password_to_mail/`, options)
    .then(checkJsonResponseWithMessage)
    .then((json) => {
      dispatch({ type: actions.EMAIL_SEND_SUCCESS })
    })
    .catch((e) => {
      dispatch({
        type: actions.EMAIL_SEND_FAIL,
        data: e
      })
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/auth/index.js